/* eslint-disable react/no-danger */

import embed from 'embed-video';
import React from 'react';

interface Props {
    url: string;
}

export const Iframe: React.FC<Props> = ({ url }) => {
    const frameClassName = 'dc-iframe__content';
    const frameAttr = {
        width: '100%',
        height: '100%',
    };
    const embedSrc = embed(url, {
        attr: {
            class: frameClassName,
            ...frameAttr,
        },
    });
    let embedContent = (
        <div
            data-spec="iframe-container"
            className="dc-iframe"
            dangerouslySetInnerHTML={{ __html: embedSrc }}
        />
    );

    // embed-video returns undefined if the embed is not recognised (youtube or vimeo)
    // and in this case we still want to show a iframe even if the URL fails to display a frame
    if (embedSrc === undefined) {
        embedContent = (
            <div data-spec="iframe-container" className="dc-iframe">
                <iframe
                    className={frameClassName}
                    {...frameAttr}
                    src={url}
                    frameBorder="0"
                    allowFullScreen
                />
            </div>
        );
    }

    return embedContent;
};
